

export default function useFlowDemoData() {

  const flowData = {
    state: { battery_soc: 94 },
    flow: {
      pv: 18,
      wallbox: 11,
      household: 4,
      to_battery: 3,
      to_grid: 0,
    },
  }


  return {
    flowData,
  }


}